import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardContent, CardHeader, CardTitle, Progress } from 'alm-react-components';
import moment from 'moment-timezone';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ActionType, constants, DateFormat, Tag } from '../../assets/constants/constants';
import { AppContext } from '../../context/AppProvider';
import useQuaterDetail from "../../hooks/useQuaterDetail";
import getLocalizedContent from '../../lib/getLocalizedMetaData';
import {
  badgeUrl,
  highLight,
  isDateInRange,
  isEnrollmentDateAvailable,
  isEnrollmentProgramOpen,
  limitOverview,
  weekCount,
  weekCountWithOutDoNotShowProgram,
} from "../../lib/utils";
import { apis } from '../../services/alm';
import { DisabledCardPopOver } from '../common/DisabledCardPopOver';
import { PopOverTitle } from '../common/PopOverTitle';
import SvgIcon from '../common/SvgIcon';

const QuaterWiseData = ({
  quaterTag,
  currentQuater,
  startDate,
  getQuaterStartData,
  setIsEnrolledProgram
}: {
  quaterTag: any;
  currentQuater: any;
  startDate: any;
  getQuaterStartData: any;
  setIsEnrolledProgram:any
}) => {
  const {state, dispatch } = useContext(AppContext);
  const [quaterWiseData, setQuaterWiseData] = useState<any>({
    data: [],
    included: [],
    completed: [],
  });
  const [enrolledProgram, setEnrolledProgram] = useState<any>({
    data: [],
    included: [],
  });
  const [progressData, setProgressData] = useState<{ [key: string]: number }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentQuarter, nextQuarter } = useQuaterDetail();
  const today = new Date(startDate);

  useEffect(() => {
    const quaterData = async () => {
      try {
        const response: any = await apis.getLearningProgram(quaterTag);
        const enrolledData = response?.data?.filter((item: any) => {
          return item.relationships.enrollment;
        });
        const enrolledCompletedId = enrolledData?.map((item: any) => {
          return item?.relationships?.enrollment?.data?.id;
        });
        const tags = response?.included
          ?.filter((res: any) => {
            return enrolledCompletedId.includes(res?.id);
          })
          ?.map((res: any) => res?.attributes?.state == constants.COMPLETED);
        const completedData = enrolledData?.filter((_: any, i: any) => tags[i]);
        /**  filter out the quater listing program 
        // sll corporate leaner have the default program listing 
        // Non sll corporate leaner have all quater program
        */
        const quaterWiseDataUnenrolled = response?.data?.filter((item: any) => {
          return !item.relationships.enrollment;
        }).filter((data:any)=>{
          return  state?.user?.sllCorporateAccount  === 1  ? data?.attributes?.tags.includes(Tag.defaultProgram) : true
        });
        let enrolledNotCompleted: any = enrolledData?.filter((_: any, i: any) => !tags[i]);
        setQuaterWiseData({
          data: [...quaterWiseDataUnenrolled, ...completedData],
          included: response?.included,
          completed: completedData,
        });
          
        
        setEnrolledProgram({
          data: enrolledNotCompleted,
          included: response?.included,
        });
        dispatch({
          type: 'SET_ENROLLMENT',
          payload: isEnrollmentProgramOpen(response?.included[0].attributes.enrollmentDeadline),
        });
        const progressData: { [key: string]: number } = {};
        for (const program of enrolledData) {
          const enrollmentId = program?.relationships?.enrollment?.data?.id;
          const progressDetails = response?.included?.find((ele: any) => ele?.id === enrollmentId);
          if (progressDetails) {
            progressData[enrollmentId] = progressDetails?.attributes?.progressPercent || 0;
          }
        }
        setProgressData(progressData);
      } catch (e) {
        console.log('error', e);
      }
    };
    quaterData();
  }, [quaterTag]);
useEffect(()=>{
if(enrolledProgram?.data.length){
  setIsEnrolledProgram(enrolledProgram?.data)
}
},[enrolledProgram])
  const currentQuarterEnd = nextQuarter?.start
    ? new Date(nextQuarter.start)
    : new Date();

  const shouldBlinkCurrentQuarter = isDateInRange(
    currentQuarter?.start || null,
    currentQuarterEnd || null,
    today || null
  );

  const onHanleEnrollment = (id: number,startDate:any) => {
    if(!isEnrollmentDateAvailable(startDate)) {
     dispatch({type:ActionType.ALERT_BOX,payload:{
               visible:true,
               message:t('AlertDialog.disablePCardMsg')
             }})
      return
    }
    const completedIds = quaterWiseData?.completed?.map((res: any) => res.id);
    let programCountEachQuarter:any=[];
    if(enrolledProgram?.data[0]){
      programCountEachQuarter=[...quaterWiseData?.data,...enrolledProgram?.data]
    }else{
      programCountEachQuarter=quaterWiseData?.data
    }
    if (completedIds.includes(id)) {
      navigate(`/program/${id}`);
    } else if(isEnrollmentDateAvailable(startDate))  {
      navigate(`/program-overview?programId=${id}`, {
        state: {
          enrolled: enrolledProgram?.data[0]?.relationships?.enrollment?.data?.id
            ? enrolledProgram?.data[0]?.relationships?.enrollment?.data?.id
            : false,
          enrolledName:  getLocalizedContent(enrolledProgram?.data[0]?.attributes?.localizedMetadata).name,
          year: quaterTag,
          programCountEachQuarter:programCountEachQuarter
        },
      });
    }
  };
  const content = getLocalizedContent(enrolledProgram?.data[0]?.attributes?.localizedMetadata);
  return (
    <>
      {/* enrollment message */}
      
      {isEnrollmentDateAvailable(startDate) && (enrolledProgram?.data?.length === 0 || !enrolledProgram?.data?.length ) && ( 
          <p className="[&:not(:first-child)]:mb-6 leading-normal">
          <span className="text-primary" dangerouslySetInnerHTML={{ __html: t('Program.quarterEnrollmentOpenMsgHighLight') }} />
          {' '}
          
          <span dangerouslySetInnerHTML={{ __html: t('Program.quarterEnrollmentOpenMsg') }} />
          <FontAwesomeIcon
            icon={faCheckCircle}
            className=" ms-4 text-2xl font-light text-primary"
          />
        </p>
      )}

      {/* Big program card */}
      {enrolledProgram?.data.length > 0 && (
          <div className="w-[100%] mx-auto ">
            <Card
              style={{
                backgroundImage: `url('${enrolledProgram?.data[0]?.attributes?.bannerUrl}')`,
              }}
              className=" bg-cover rounded-2xl bg-center border border-cardBorder dark:border-cardBorder"
            >
              <CardContent className="grid gap-4 md:py-10 md:px-8 md:pb-7">
                <div className="flex items-start  justify-between">
                  <div className="flex-1 min-w-0 me-4">
                    <div className="relative">
                      <div className="flex items-center text-xs border max-sm:mt-4 p-2 py-1 absolute top-0 left-0 rounded-md text-white px-1.5 bg-[#181818] w-[max-content]">
                        <p
                          className={`w-[8px] h-[8px] ${shouldBlinkCurrentQuarter
                              ? "rounded-full bg-red-500 circle mt-2 ml-2"
                              : "rounded-lg bg-red-500"
                            }`}
                        ></p>
                        <p className="mx-2 uppercase text-red-50">
                          <span dangerouslySetInnerHTML={{ __html: t("Program.liveProgram") }} />
                        </p>
                      </div>
                    </div>
                    <h4 className="mb-2 mt-20 lg:text-lg uppercase font-barlowLight text-left tracking-wider">
                      <span dangerouslySetInnerHTML={{ __html: t("Program.text") }} />
                    </h4>
                    <h1 className="mb-6 leading-none font-barlowRegular text-white md:text-3xl lg:text-4xl text-left">
                      {content?.name}
                    </h1>
                    <p className="mb-10 text-base font-opensansRegular text-left md:w-[52%]">
                      {content?.description &&
                        limitOverview(content?.description)}
                    </p>
                  </div>
                  <div className="flex-shrink-0 inline-flex items-center text-base font-helveticaMedium text-gray-900 dark:text-white">
                    <img
                      className="yellow max-w-[84px]"
                      src={badgeUrl(
                        enrolledProgram.data[0].relationships?.instances
                          ?.data[0]?.id,
                        enrolledProgram?.included
                      )}
                      alt="Basics image"
                    />
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="flex-1 min-w-0 me-4 mb-2">
                    <p className="leading-7 text-base [&:not(:first-child)]:mt-6 md:w-72 dark:text-gray-300 font-light">
                      <span className="capitalize">{moment(startDate).format(DateFormat)}
                      </span> |{" "}
                      <span>
                        {weekCount(enrolledProgram)} <span dangerouslySetInnerHTML={{ __html: t("Common.weeks") }} />
                      </span>
                    </p>
                  </div>
                  <div className="flex-shrink-0 inline-flex items-center  text-base font-opensansSemiBold text-gray-900 dark:text-white mb-2">
                    <Button
                      onClick={() =>
                        navigate(`/program/${enrolledProgram?.data[0]?.id}`)
                      }
                      // variant="outline"
                      className="w-full flex items-start gap-2 space-y-1.5 md:px-8 space-x-1.5 md:min-h-10  mt-12 h-auto py-2 text-base mb-4 truncate "
                    >
                      <span dangerouslySetInnerHTML={{ __html: t("Program.goToProgram") }} />
                      <SvgIcon
                        iconName="right-line-arrow" //name of svg file
                        svgProp={{
                          className: 'logo cursor-pointer',
                        }}
                      />
                      {/* <FontAwesomeIcon
                        icon={faArrowRight}
                        className=" ms-3 text-sm"
                      /> */}
                    </Button>
                  </div>
                </div>
              </CardContent>
              <div className="bg-fillLightGrayCard p-5 rounded-t-none rounded-b-2xl border-1 border border-cardBorder">
                <div className="flex items-center">
                  <div className="flex-1 min-w-0">
                    <Progress
                      value={
                        progressData &&
                        progressData[
                        enrolledProgram?.data[0]?.relationships?.enrollment
                          ?.data?.id
                        ]
                      }
                      className="w-full h-[7px] bg-fillDarkGrayCard"
                    />
                  </div>
                </div>
              </div>
            </Card>
          </div>
      )}

      <div className="max-sm:flex-wrap max-sm:flex-col sm:flex-wrap sm:flex-col md:flex-wrap lg:flex-nowrap gap-5 items-stretch mt-10 -ml-0 md:-ml-5 portrait:sm:-ml-0 portrait:md:-ml-5 flex lg:flex-row lg:gap-0 md:gap-0 md:gap-y-5 md:flex md:flex-row">
        {quaterWiseData?.data?.sort((a: any, b: any) => b?.attributes?.localizedMetadata[0]?.name.localeCompare(a?.attributes?.localizedMetadata[0]?.name, 'es', { sensitivity: 'base' })).slice(0, 2).map((item: any, index: number) => {
          return (
              <div
                key={index + item?.id}
                className="landscape:2xl:basis-1/2 landscape:xl:basis-1/2 landscape:lg:basis-1/2 landscape:md:basis-1/1 portrait:md:basis-1/1 md:pl-5 w-full"
              >
                <DisabledCardPopOver
                text={t('AlertDialog.disablePCardMsg')}
                component={
                <Card
                  className={`w-full sm:w-full cursor-pointer h-auto p-0 border-cardBorder common-card-bg flex overflow-hidden max-md:flex-col`}
                  onClick={() => onHanleEnrollment(item?.id,startDate)}
                >
                  <CardHeader className="p-0 relative space-y-0 h-[211px] overflow-hidden w-full">
                    <div className="absolute top-0 left-0 flex gap-2 items-center text-xs ml-4 mt-4 border bg-[#181818] p-[3px] rounded-md text-white px-1.5">
                      <p
                        className={`${isEnrollmentDateAvailable(startDate)
                            ? "w-[8px] h-[8px] rounded-full bg-red-500 circle mt-2 ml-2 "
                            : "w-[8px] h-[8px] rounded-lg bg-red-500"
                          }`}
                      ></p>
                      <p
                        className={`${isEnrollmentDateAvailable(startDate) ? "mx-0" : ""
                          } uppercase text-red-50`}
                      >
                        <span dangerouslySetInnerHTML={{ __html: t("Program.liveProgram") }} />
                      </p>
                    </div>
                    {quaterWiseData?.completed?.map(
                      (res: any, index: number) => {
                        return res?.id === item.id ? (
                          <>
                            <div
                              key={index + "_" + res?.id}
                              className="absolute top-4 right-0 flex gap-2 items-center text-xs me-4 mt-4 border bg-[#181818] p-[3px] rounded-md text-white px-1.5"
                            >
                              <p
                                className={`${isEnrollmentDateAvailable(startDate)
                                    ? "mx-3"
                                    : ""
                                  } uppercase text-red-50`}
                              >
                                <span dangerouslySetInnerHTML={{ __html: t("Common.completed") }} />
                              </p>
                            </div>
                          </>
                        ) : (
                          ""
                        );
                      }
                    )}

                    <img
                      src={item?.attributes?.imageUrl}
                      alt="No Image"
                      className={`w-full h-[inherit] object-cover object-center bg-center lg:col-span-full rounded-xl rounded-tr-none rounded-b-none bg-fillLightGrayCard`}
                    />
                  </CardHeader>
                  <CardContent className="px-6 mt-6 xl:min-h-36 lg:min-h-full w-[inherit]">
                    <div className="flex flex-row justify-between">
                      <CardTitle className="text-wrap lg:text-xl xl:text-2xl font-barlowMedium truncate">
                        {getLocalizedContent(item?.attributes?.localizedMetadata).name}
                      </CardTitle>
                      <PopOverTitle
                        name={getLocalizedContent(item?.attributes?.localizedMetadata).name}
                      />
                      <img
                        src={badgeUrl(
                          item?.relationships?.instances?.data[0]?.id,
                          quaterWiseData?.included
                        )}
                        alt="No image"
                        className={`${highLight(
                          quaterTag?.split("-")[0],
                          currentQuater,
                          getQuaterStartData
                        ) || isEnrollmentDateAvailable(startDate)
                            ? "yellow"
                            : ""
                          } w-[85px] h-[59px] basis-[content] ms-2`}
                      />
                    </div>
                    <div className="flex mt-8 text-base font-opensansLight whitespace-nowrap">
                      {/* {startDate ? formatDate(new Date(startDate)) : ""} */}
                       <span className="capitalize">
                      {startDate ? moment(startDate).isValid() ? moment(startDate).format(DateFormat) : "" : ""}
                      </span>
                      <div className="ms-2">
                        | {weekCountWithOutDoNotShowProgram(item)}{" "}
                        <span dangerouslySetInnerHTML={{ __html: t("Common.weeks") }} />
                      </div>
                    </div>
                  </CardContent>
                </Card>
                }
                show={!isEnrollmentDateAvailable(startDate)}
                />
              </div>
          );
        })}
      </div>
    </>
  );
};

export default React.memo(QuaterWiseData);
